<div class="row pt-4 mb-5">
    <div class="col-md-5">
        <div class="card p-3 mb-4">
            <form  role="form" [formGroup]="formCadastroAprovadores" (ngSubmit)="envioAprovador()">
                <h5 *ngIf="!editandoAprovador" class="my-2">Cadastro Aprovadores</h5>
                <h5 *ngIf="editandoAprovador" class="my-2">Edição de Aprovadores</h5>
                <hr>
                <div class="form-group">
                    <strong for="loginAprovador">Login *</strong>
                    <input type="text"
                        (blur)="validarLoginAprovador($event.target.value)"
                        class="form-control" 
                        name="loginAprovador"
                        id="loginAprovador"
                        formControlName="loginAprovador" 
                        placeholder="Digite o login do Aprovador" 
                        [readonly]="!podeEditarAprovador"
                    required>
                </div>
                <div class="form-group">
                    <strong for="senhaAprovador">Senha *</strong>
                    <input type="password"
                        (blur)="validarSenhaAprovador($event.target.value)"
                        class="form-control"
                        name="senhaAprovador"
                        id="senhaAprovador"
                        formControlName="senhaAprovador"
                        placeholder="Digite a senha do Aprovador" 
                    required>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-start bag">
                    <button class="btn btn-outline-secondary buttoncustom" (click)="gerarSenha()"><i class="fas fa-dice dicesmall"></i>Gerar senha</button>
                    <p class="ml-3 p-0 m-0"><strong>{{randomSenha}}</strong></p>
                </div>
                <div *ngIf="validaSenha == true" class="form-group">
                    <strong for="confirmarSenhaAprovador">Confirmar Senha</strong>
                    <input type="password"
                        (blur)="validarConfirmaSenhaAprovador($event.target.value)"
                        class="form-control"
                        name="confirmarSenhaAprovador"
                        id="confirmarSenhaAprovador"
                        formControlName="confirmarSenhAprovador"
                        placeholder="Confirme a senha do aprovador" 
                    required>
                </div>
                <div class="row form-group">
                    <div class="col-12">
                    <strong for="aprovadorauth1">Informação Autenticação 1 *</strong>
                    <input type="text"
                        (blur)="validarInformacoesAutenticacao(1)"
                        class="form-control" 
                        name="aprovadorauth1"
                        id="aprovadorauth1"
                        formControlName="aprovadorauth1" 
                        placeholder="Digite a primeira Informação de Autenticação" 
                        [readonly]="!podeEditarAprovador"
                    required>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-12">
                    <strong for="aprovadorauth2">Informação Autenticação 2 *</strong>
                    <input type="text"
                        (blur)="validarInformacoesAutenticacao(2)"
                        class="form-control" 
                        name="aprovadorauth2"
                        id="aprovadorauth2"
                        formControlName="aprovadorauth2" 
                        placeholder="Digite a segunda Informação de Autenticação" 
                        [readonly]="!podeEditarAprovador"
                    required>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <strong for="emailAprovador">Email</strong>
                            <input type="text"
                                (blur)="validarEmailAprovador($event.target.value)"
                                class="form-control" 
                                name="emailAprovador"
                                id="emailAprovador"
                                formControlName="emailAprovador" 
                                placeholder="Digite o email do aprovador">
                        </div>
                    </div>
                </div>
                <button *ngIf="!editandoAprovador" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar</button>
                <button *ngIf="editandoAprovador" [disabled]="btOff" type="submit" class="btn btn-success btn-custom">Salvar edição</button>
                <button *ngIf="editandoAprovador" (click)="cancelarEdicao()" type="button" class="btn btn-light btn-custom mr-2">Cancelar edição</button>
            </form>
        </div>
    </div>
    <div class="col-md-7">
        <div class="card p-3 mb-4" *ngIf="aprovadores && aprovadores.length > 0">
            <form  role="form" [formGroup]="formQtAprovadores" (ngSubmit)="envioQtAprovadores()">
                <h5 class="my-2">Quantidade de Aprovadores para Deferimento</h5>
                <hr>
                <div class="form-group">
                    <strong for="qtAprovadoresDeferimento">Quantidade de Aprovadores Para Deferimento*</strong>
                    <input type="text"
                        (blur)="validarQtAprovadoresDeferimento($event.target.value)"
                        class="form-control" 
                        name="qtAprovadoresDeferimento"
                        id="qtAprovadoresDeferimento"
                        formControlName="qtAprovadoresDeferimento" 
                        placeholder="Digite a quantidade de Aprovadores Para Deferimento" 
                    required>
                </div>                
                            
                <button [disabled]="btQtOff" type="submit" class="btn btn-success btn-custom">Salvar</button>
            </form>
        </div>
        <div class="card p-3"  style="position: relative;">
            <div *ngIf="carregandoAprovadores == true" class="carregando">
                <div class="c-loader"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
                <h5 class="mb-0 mr-auto">Aprovadores</h5> 
                <!--<div class="justify-items-end">
                    <button class="btn mr-2 btn-light ml-auto" (click)="baixarTemplate()" pTooltip="Baixar modelo de importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-success ml-auto" data-toggle="modal" data-target="#modalcsv" pTooltip="Importar Aprovadores">
                        <i class="fas fa-file-csv"></i>
                    </button>
                </div>-->
                <div  class="justify-items-end">
                    <button [disabled]="btOff" (click)="envioAprovadores()" class="btn btn-success btn-custom" pTooltip="Clique para disparar os E-mails">
                        <i class="fa fa-share"></i>  Enviar Credenciais
                    </button>
                </div>

            </div>
            <hr>
            <div class="input-group mb-3">
                <input type="text" class="form-control" id="filtroAprovador" placeholder="Digite o login do aprovador para buscar">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" style="font-size:15px!important;" (click)="filtrarAprovadoresPorNome()"><i class="fas fa-search"></i></button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" style="font-size:15px!important;" (click)="limparFiltro()"><i class="fas fa-eraser"></i></button>
                  </div>
            </div>         
            <table class="table table-bordered">
                
                <thead>
                    <tr>
                        <th style="width: 90%;">Login</th>
                        <th class="text-center" colspan="2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let aprovador of aprovadores">
                        <td>{{aprovador.login}}</td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="editar" (click)="editarAprovador(aprovador)">
                                <i class="fas fa-edit fa-sm"></i>
                            </button>
                        </td>
                        <td class="text-center">
                            <button class="btn p-1 act" data-toggle="tooltip" title="excluir" (click)="excluirAprovador(aprovador.id)" [disabled]="btOff">
                                <i class="fas fa-trash fa-xs"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <paginationAprovador [page]="page" (paginationEvent)=changePage($event)></paginationAprovador>
        </div>
    </div>
</div>

<!-- The Modal -->
<!--
<div class="modal fade" id="modalcsv"  #content>
    <app-massa-aprovador></app-massa-aprovador>
</div>-->